import { render, staticRenderFns } from "./codemirror.vue?vue&type=template&id=461f1c70&scoped=true&"
import script from "./codemirror.vue?vue&type=script&lang=js&"
export * from "./codemirror.vue?vue&type=script&lang=js&"
import style0 from "./codemirror.vue?vue&type=style&index=0&id=461f1c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461f1c70",
  null
  
)

export default component.exports